import { queryOptions } from "@tanstack/react-query";
import { backendService } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";

export const queryOptions_coreValuesChosen = () =>
	queryOptions({
		queryKey: ["core-values", "chosen"] as const,
		queryFn: (context) =>
			extractionWrapper(
				backendService.corevalues.chosenCoreValuesControllerGetAll({
					signal: context.signal,
				}),
			),
	});
